const normalizeHsBaseUrl = (baseUrl: string): string => {
    try {
        const url = new URL(baseUrl);
        if (url.hostname === '0.0.0.0') {
            url.hostname = 'localhost';
        }

        return url.toString().replace(/\/$/, '');
    } catch {
        return baseUrl.replace(/\/$/, '');
    }
};

export const HS_BASE_URL = normalizeHsBaseUrl(
    import.meta.env.VITE_HS_BASE_URL || (import.meta.env.DEV ? 'http://localhost:8011' : 'https://www.pokersolutions.com')
);

export const getPokerToken = (): string | null => {
    try {
        const params = new URLSearchParams(window.location.search);
        const urlToken = params.get('token');
        if (urlToken && urlToken.length > 0) return urlToken;
    } catch {}
    try {
        const stored = localStorage.getItem('sessionToken');
        if (stored && stored.length > 0) return stored;
    } catch {}
    return null;
};

export const appendPokerTokenToUrl = (baseUrl: string): string => {
    try {
        const token = getPokerToken();
        const url = new URL(baseUrl);
        if (token) {
            url.searchParams.set('pokerToken', token);
        }
        return url.toString();
    } catch {
        return baseUrl;
    }
};

export const buildHsUrlWithToken = (relativePath: string): string => {
    const path = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
    return appendPokerTokenToUrl(`${HS_BASE_URL}${path}`);
};
